/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import AuthProviderCreation from './AuthProviderCreation';

const AuthProviderBtn = () => {
    const [openAuthProviderCreationModal, setOpenAuthProviderCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenAuthProviderCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenAuthProviderCreationModal(true)}  >Register Identity Provider</Button>
            <DialogContainer
                open={openAuthProviderCreationModal}
                handleClose={handleCloseDialog}
            >
                <AuthProviderCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default AuthProviderBtn;
